import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { Layers, Newspaper, BookOpen, Users, Inbox, ArrowRight } from "lucide-react";

const Stat = ({ label, value, icon: Icon, to }) => (
    <Link to={to} className="bg-card border border-border rounded-sm p-6 hover:border-primary/60 transition-colors group" data-testid={`stat-${label.toLowerCase()}`}>
        <div className="flex items-start justify-between">
            <div>
                <div className="text-xs uppercase tracking-[0.22em] text-muted-foreground mb-2">{label}</div>
                <div className="font-display text-4xl">{value}</div>
            </div>
            <Icon size={20} className="text-primary opacity-70 group-hover:opacity-100" />
        </div>
        <div className="mt-4 text-xs inline-flex items-center gap-1 text-primary opacity-0 group-hover:opacity-100 transition-opacity">Manage <ArrowRight size={12} /></div>
    </Link>
);

export default function Dashboard() {
    const [stats, setStats] = useState({ programs: 0, news: 0, resources: 0, leaders: 0, inquiries: 0, unread: 0 });
    useEffect(() => {
        (async () => {
            const [p, n, r, l, i] = await Promise.all([
                api.get("/programs?all=true"),
                api.get("/news?all=true"),
                api.get("/resources?all=true"),
                api.get("/leadership"),
                api.get("/inquiries"),
            ]);
            setStats({
                programs: p.data.length,
                news: n.data.length,
                resources: r.data.length,
                leaders: l.data.length,
                inquiries: i.data.length,
                unread: i.data.filter((x) => !x.read).length,
            });
        })().catch(() => {});
    }, []);

    return (
        <div data-testid="admin-dashboard">
            <h1 className="font-display text-4xl mb-2">Welcome back</h1>
            <p className="text-muted-foreground mb-10">Manage your website content, brand, and inquiries from this dashboard.</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
                <Stat label="Programs" value={stats.programs} icon={Layers} to="/admin/programs" />
                <Stat label="News" value={stats.news} icon={Newspaper} to="/admin/news" />
                <Stat label="Resources" value={stats.resources} icon={BookOpen} to="/admin/resources" />
                <Stat label="Leaders" value={stats.leaders} icon={Users} to="/admin/leadership" />
                <Stat label="Inquiries" value={`${stats.unread}/${stats.inquiries}`} icon={Inbox} to="/admin/inquiries" />
            </div>

            <div className="mt-12 grid lg:grid-cols-3 gap-6">
                <Link to="/admin/pages" className="bg-card border border-border rounded-sm p-8 hover:border-primary/60 transition-colors">
                    <h3 className="font-display text-2xl mb-2">Edit page content</h3>
                    <p className="text-sm text-muted-foreground">Home hero, mission, about page, vision & values.</p>
                </Link>
                <Link to="/admin/settings" className="bg-card border border-border rounded-sm p-8 hover:border-primary/60 transition-colors">
                    <h3 className="font-display text-2xl mb-2">Theme & branding</h3>
                    <p className="text-sm text-muted-foreground">Colors, fonts, footer, social links, animations, SEO.</p>
                </Link>
                <Link to="/admin/inquiries" className="bg-card border border-border rounded-sm p-8 hover:border-primary/60 transition-colors">
                    <h3 className="font-display text-2xl mb-2">Inquiries inbox</h3>
                    <p className="text-sm text-muted-foreground">Partnership requests, donations, consultancy & jobs.</p>
                </Link>
            </div>
        </div>
    );
}
